<template>
  <Popup :isVisible="isVisible" @close="$emit('close')" :maxWidth="909">
    <!-- TOTE bag popup content -->
    <div class="tote-bag-popup">
      <div class="tote-bag-content">
        <div class="tote-bag-image">
          <ImageWrapper
            src="/assets/images/tote-bag-bg.png"
            class="product-image-bg"
            alt=""
          />
          <ImageWrapper
            src="/assets/images/tote-bag-product.png"
            alt="Ash Limited edition tote bag"
            class="product-image"
            v-if="type == 1"
          />
          <ImageWrapper
            src="/assets/images/tote-bag-product-red.png"
            alt="Ash Limited edition tote bag red"
            class="product-image"
            v-else-if="type == 2"
          />
          <ImageWrapper
            src="/assets/images/gift-coffee-cups.png"
            alt="coffee cups"
            class="product-image"
            v-else-if="type == 3"
          />
          <ImageWrapper
            src="/assets/images/2025/banner_mobile_mini_caps_2.png"
            alt="mini caps"
            class="product-image"
            v-else-if="type == 4"
          />
          <ImageWrapper
            src="/assets/images/2025/banner_mobile_vert_caps.png"
            alt="mini caps"
            class="product-image"
            v-else-if="type == 5"
          />
        </div>
        <div class="tote-bag-details" v-if="type == 1 || type == 2">
          <h2 class="product-title" v-html="$t('toteBag.title')"></h2>
          <p class="product-description" v-html="$t('toteBag.description')"></p>
        </div>
        <div class="tote-bag-details" v-else-if="type == 3">
          <h2 class="product-title" v-html="$t('giftCups.title')"></h2>
          <p
            class="product-description"
            v-html="$t('giftCups.description')"
          ></p>
        </div>
        <div class="tote-bag-details" v-else-if="type == 4">
          <h2 class="product-title" v-html="$t('miniCaps.title')"></h2>
          <p
            class="product-description"
            v-html="$t('miniCaps.description')"
          ></p>
        </div>
        <div class="tote-bag-details" v-else-if="type == 5">
          <h2 class="product-title" v-html="$t('vlCaps.title')"></h2>
          <p class="product-description" v-html="$t('vlCaps.description')"></p>
        </div>
      </div>
    </div>
  </Popup>
</template>

<script>
import Popup from "../molecules/Popup.vue";
import ImageWrapper from "../atoms/ImageWrapper.vue";

export default {
  name: "TotteBagPopup",

  components: {
    Popup,
    ImageWrapper,
  },

  props: {
    /**
     * Controls the visibility of the popup
     * @type {Boolean}
     */
    isVisible: {
      type: Boolean,
      default: false,
    },
    /**
     * Tote bag type (1 or 2)
     * @type {Number}
     */
    type: {
      type: Number,
      default: 1,
      validator: (value) => [1, 2, 3].includes(value),
    },
  },

  /**
   * Emits close event when popup is closed
   */
  emits: ["close"],
};
</script>

<style lang="scss" scoped>
@import "~/scss/include/_commonInclude.scss";

.content {
  // TOTE bag popup styles
  .tote-bag-popup {
    .tote-bag-content {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: rem(56);
      padding: rem(24);

      @include media-breakpoint-down(md) {
        flex-direction: column;
        gap: rem(24);
        text-align: center;
      }

      .tote-bag-image {
        flex-shrink: 0;
        width: rem(256);
        height: rem(341);
        position: relative;
        overflow: visible;

        @include media-breakpoint-down(md) {
          width: rem(200);
          height: rem(266);
        }
        .product-image-bg {
          position: absolute;
          width: 214%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .product-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: rem(8);
          position: relative;
        }
      }

      .tote-bag-details {
        flex: 1;
        max-width: rem(382);

        .product-title {
          font-family: "Nespresso Lucas", sans-serif;
          font-weight: 700;
          font-size: rem(32);
          line-height: 1.2;
          color: color(black);
          text-transform: uppercase;
          margin-bottom: rem(24);

          @include media-breakpoint-down(md) {
            font-size: rem(24);
            margin-bottom: rem(16);
          }
        }

        .product-description {
          font-family: "Nespresso Lucas", sans-serif;
          font-weight: 400;
          font-size: rem(16);
          line-height: 1.2;
          letter-spacing: rem(0.8);
          color: color(black);
          margin: 0;

          @include media-breakpoint-down(md) {
            font-size: rem(14);
          }
        }
      }
    }
  }
}
</style>
